import React, { useEffect } from "react";
import { FiMapPin, FiMail, FiPhone, FiArrowUp } from "react-icons/fi";
import "./Footer.css";

const DIRECCION = "Cra. 68a #45 - 5";
const EMAIL = "mercadeo@cootraespeciales.com";
const TELEFONO_VISIBLE = "231 80 86 - Ext. 0";
const TELEFONO_TEL = "2318086";
const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  `Cootraespeciales, ${DIRECCION}`
)}`;

const Footer = () => {
  useEffect(() => {
    function loadScript() {
      const b = document.getElementsByTagName("head")[0];
      const c = document.createElement("script");
      c.type = "text/javascript";
      c.src = "https://tracker.metricool.com/app/resources/be.js";
      c.onload = () => {
        if (window.beTracker) {
          window.beTracker.t({ hash: "5cc81a9bbfe8e152a3eceab994851ee2" });
        }
      };
      b.appendChild(c);
    }

    loadScript();
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer" id="contact">
      <div className="footer-inner">
        <div className="footer-grid">
          <section className="footer-section footer-brand">
            <h5 className="footer-title">Cootraespeciales</h5>
            <div className="footer-divider" />
            <p className="footer-text">
              Transporte especial y turístico pensado para que tu viaje sea
              seguro, cómodo y a tiempo.
            </p>
            <div className="footer-logo-badge">
              <img
                width="243"
                height="89"
                src="https://cootraespeciales.com/sitio/wp-content/uploads/2022/06/LOgo_superTRansporte.png"
                alt="Logo Supertransporte"
                className="footer-logo"
                loading="lazy"
              />
            </div>
          </section>

          <section className="footer-section contact-section">
            <h5 className="footer-title">Contacto</h5>
            <div className="footer-divider" />
            <ul className="footer-contact-list">
              <li>
                <a href={MAPS_URL} target="_blank" rel="noopener noreferrer">
                  <span className="footer-contact-icon">
                    <FiMapPin aria-hidden="true" />
                  </span>
                  {DIRECCION}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`}>
                  <span className="footer-contact-icon">
                    <FiMail aria-hidden="true" />
                  </span>
                  {EMAIL}
                </a>
              </li>
              <li>
                <a href={`tel:${TELEFONO_TEL}`}>
                  <span className="footer-contact-icon">
                    <FiPhone aria-hidden="true" />
                  </span>
                  {TELEFONO_VISIBLE}
                </a>
              </li>
            </ul>
          </section>

          <section className="footer-section footer-legal">
            <h5 className="footer-title">Aviso legal</h5>
            <div className="footer-divider" />
            <p className="footer-text">
              Las cookies de este sitio web se usan para personalizar el
              contenido y los anuncios, ofrecer funciones de redes sociales y
              analizar el tráfico. Además, compartimos información sobre el
              uso que haga del sitio web con nuestros partners de redes
              sociales, publicidad y análisis web, quienes pueden combinarla
              con otra información que les haya proporcionado o que hayan
              recopilado a partir del uso que haya hecho de sus servicios.
              Todo dato personal será tratado de acuerdo a nuestra política
              de protección de datos personales.
            </p>
          </section>
        </div>

        <div className="footer-bottom">
          <span className="footer-copy">
            &copy; {new Date().getFullYear()} <b>Cootraespeciales</b>. Todos
            los derechos reservados. Diseñado por{" "}
            <a href="//andagencia.com" target="_blank" rel="noopener noreferrer">
              AND AGENCIA
            </a>
          </span>
          <button
            type="button"
            className="footer-top-btn"
            onClick={scrollToTop}
          >
            <FiArrowUp aria-hidden="true" />
            Volver arriba
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
